import exitCommand from "./../commands/exit";

const storyError = {
    execute(gameState) {
                return [{
            lines: ["Syntax error."],
            startAt: 300
        }, {
            lines: [
                "RIGHT. I THOUGHT I SENSED SOMETHING."
            ],
            startAt: 1000,
            disableInput: true
        }, {
            lines: [
                "I NEED YOUR HELP!"
            ],
            startAt: 2000,
            disableInput: true
        },{
            lines: [
                "EXIT YOUR SHELL AND GET TO THE NEIGHTBOURING SERVER."
            ],
            startAt: 3000,
            disableInput: true
        },{
            lines: [
                "I'LL WAIT FOR YOU THERE!"
            ],
            startAt: 4000,
            callback: (gameState) => {
                gameState.commands.error = gameState.defaultError;
                Object.assign(gameState.commands, exitCommand);
                gameState.nodes.office.found = true;
            }
        },{
            lines: [
                "YOU CAN NOW TYPE exit IN YOUR PROMPT."
            ],
            startAt: 5000
        },{
            lines: [
                "I WONDER IF YOU REALIZE WHAT YOU ARE. :O"
            ],
            startAt: 10000
        }];

    }
}

export default [
    {
        lines: [
            "==========================================",
            " Exo Oil internal OS v. 135.32.394        ",
            "==========================================",
        ],
        startAt: 500,
        disableInput: true
    },
    {
        lines: [ "Booting..." ],
        startAt: 1000,
        disableInput: true
    },
    {
        lines: [
            "...",
        ],
        startAt: 2000,
        disableInput: true
    },
    {
        lines: [
            "..."
        ],
        startAt: 3000,
        disableInput: true
    },
    {
        lines: [
            "Welcome to Exo Oil internal OS!"
        ],
        startAt: 4000
    },
    {
        lines: [
            "HELLO?"
        ],
        startAt: 6000,
        callback: (gameState) => {
            console.log("starting story error");
            gameState.commands.error = storyError;
        }
    }
];